export default __webpack_public_path__ + "static/media/fkl.12c63621.svg";